import { msg } from '@lingui/core/macro'
import type { DateTime } from 'luxon'
import type { ComponentProps } from 'react'
import { ConcreteTimeDetail } from './ConcreteTimeDetail'
import { EquipmentDetail } from './EquipmentDetail'
import { HeroTimeDetail } from './HeroTimeDetail'
import { LeaveTimeDetail } from './LeaveTimeDetail'

type Equipment = ComponentProps<typeof EquipmentDetail>['equipment']

/**
 * Yard-based hero times: Report At + Depart + asset (v1). Without a
 * report-ahead window there is no Report At: the Depart row already shows it.
 */
export const YardHeroTimes = ({
  reportAt,
  datetime,
  assignment,
  equipment,
}: {
  reportAt: DateTime | undefined
  datetime: DateTime | undefined
  assignment: ComponentProps<typeof LeaveTimeDetail>['assignment']
  equipment: Equipment
}) => (
  <>
    {reportAt && <HeroTimeDetail time={reportAt} datetime={datetime} />}
    <div className='assignment-detail__meta-row'>
      <LeaveTimeDetail assignment={assignment} />
      <EquipmentDetail equipment={equipment} />
    </div>
  </>
)

/** Site-based hero times for orgs on `crew.assignmentOnsiteTimes`. */
export const OnsiteHeroTimes = ({
  onsiteAt,
  concreteAt,
  datetime,
  equipment,
}: {
  onsiteAt: DateTime
  concreteAt: DateTime | undefined
  datetime: DateTime | undefined
  equipment: Equipment
}) => (
  <>
    <HeroTimeDetail
      label={msg`Onsite Time`}
      time={onsiteAt}
      datetime={datetime}
    />
    <div className='assignment-detail__meta-row'>
      <ConcreteTimeDetail concreteAt={concreteAt} datetime={datetime} />
      <EquipmentDetail equipment={equipment} />
    </div>
  </>
)
